import React, { useEffect, useState } from 'react';
import { ErrorMessage } from '../errors/ErrorMessage';
import { Dropzone, Props as DropzoneProps } from './Dropzone';
import { UploadError } from './FileUploader';
import styles from './Dropzone.module.scss';

export const DropzoneWithErrors = ({
    additionalErrors = [],
    ...props
}: Props) => {

    const [isSuccess, setIsSuccess] = useState(false);
    const [errors, setErrors] = useState<string[]>([]);

    const handleUploads = (files: File[]) => {
        props.onChange(files);
        setIsSuccess(true);
    };

    const handleErrors = (errors: UploadError[]) => {
        setErrors(errors.map(e => e.text));
    };

    useEffect(() => {
        if (additionalErrors.length > 0 || errors.length > 0) {
            setIsSuccess(false);
        }
    }, [additionalErrors, errors]);

    const allErrors = [...errors, ...additionalErrors.map(e => e.text)];

    return (
        <>
            <Dropzone
                {...props}
                isSuccess={isSuccess}
                onError={handleErrors}
                onChange={handleUploads} />

            {allErrors.length > 0 && (
                <ErrorMessage className={styles.alert}>
                    {allErrors}
                </ErrorMessage>
            )}
        </>
    );
};

export type Props = Omit<DropzoneProps, 'onError'> & {
    additionalErrors?: UploadError[];
};